import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { useMessage } from '@tmapy/intl';
import { useSelector } from '@tmapy/redux';
import { AGSLayerLegend } from './AGSLayerLegend';
import { LayerLegend, LinkLegend } from './LayerLegend';
import { VectorLayerLegend } from './VectorLayerLegend';
import { WMSLayerLegend } from './WMSLayerLegend';
import './Legend.scss';
export const Legend = React.memo((props) => {
    const formatMessage = useMessage();
    const legends = useSelector((state) => state.legend);
    // TODO: Fix the behavior of layers – currently very demanding for component rendering
    const { layers } = useSelector((state) => state.mapCore);
    const visibleLegendData = useMemo(() => {
        const layerMap = new Map(layers.map((layer) => [layer.id, layer]));
        return legends
            .map((legend) => {
            const layer = layerMap.get(legend.layerId);
            const label = formatMessage.fallback([`layer.${legend.layerId}`]) || legend.label || legend.layerId;
            return {
                ...legend,
                label,
                layer,
            };
        })
            .filter((legendData) => legendData.layer?.layerOptions.visible)
            .map((legendData) => {
            const { layer, ...restLegendProps } = legendData;
            return {
                ...restLegendProps,
                getToken: layer?.auth ? props.getToken : undefined,
            };
        });
    }, [formatMessage, legends, layers, props.getToken]);
    return (_jsx("div", { className: 'lgd-legend', children: visibleLegendData.map((legendProps) => {
            if (legendProps.imageSrc) {
                return (_jsx(LayerLegend, { ...legendProps, children: _jsx("img", { src: legendProps.imageSrc, alt: '' }) }, legendProps.layerId));
            }
            else {
                switch (legendProps.type) {
                    case 'FeatureArcGIS':
                    case 'TileArcGISRest':
                    case 'ImageArcGISRest':
                        return _jsx(AGSLayerLegend, { ...legendProps }, legendProps.layerId);
                    case 'ImageWMS':
                        return _jsx(WMSLayerLegend, { ...legendProps }, legendProps.layerId);
                    case 'VectorTile':
                    case 'Vector':
                    case 'Tile':
                        return _jsx(VectorLayerLegend, { ...legendProps }, legendProps.layerId);
                    default:
                        return _jsx(LinkLegend, { ...legendProps }, legendProps.layerId);
                }
            }
        }) }));
});
//# sourceMappingURL=Legend.js.map